import { Link } from '@inertiajs/react';

import Container from '@/components/public/ui/Container';
import { useSite } from '@/hooks/useSite';
import { trackUmamiEvent } from '@/lib/analytics';

// Thin official strip above the masthead. Signals "this is the real council
// site" and offers the two utility links. Part of the site chrome — rendered
// once by Navbar.
export default function UtilityBar() {
  const site = useSite();
  return (
    <div className="section-ink text-[13px]">
      <Container className="flex flex-wrap items-center gap-x-5 gap-y-1 py-2">
        <span className="inline-flex items-center gap-2 font-semibold tracking-wide">
          <span className="bg-gold-leaf h-1.5 w-1.5 rounded-full shadow-[0_0_0_3px_rgba(201,162,58,0.25)]" />
          Site oficial · Junta de Freguesia
        </span>
        {site.district && (
          <span className="hidden text-[#ece5d7]/55 sm:inline">Distrito de {site.district}</span>
        )}
        <span className="ml-auto flex gap-5">
          <Link
            href="/contact"
            onClick={() =>
              trackUmamiEvent('utility_link_click', { label: 'Contactos', target: '/contact' })
            }
            className="text-[#ece5d7] no-underline hover:underline"
          >
            Contactos
          </Link>
          <Link
            href="/accessibility"
            onClick={() =>
              trackUmamiEvent('utility_link_click', {
                label: 'Acessibilidade',
                target: '/accessibility',
              })
            }
            className="text-[#ece5d7] no-underline hover:underline"
          >
            Acessibilidade
          </Link>
        </span>
      </Container>
    </div>
  );
}
